import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AccordionComponent } from "@/app/components/projects/project-stages/accordion/accordion.component";

@Component({
  selector: 'app-custom-generated',
  standalone: true,
  imports: [AccordionComponent],
  templateUrl: './custom-generated.component.html',
  styleUrl: './custom-generated.component.css'
})
export class CustomGeneratedComponent {
  constructor(private router: Router) {}


  navigateToManualSetup() {
    this.router.navigate(['/generate-manually']);
  }
}
